import Http from "../../Utils/Http";
import {localDevCatch} from "../../Utils/utils";
import {mockedTemplates} from "../Instances/InstancesService.mock";

export const getGrades = async () => {
    const result = await Http.get(`/grades-api/grades`)
        .then(res => res.data)
        .catch((err) => localDevCatch(err, mockedTemplates));
    return result;
};